import "./Switch.scss"

import React, { FunctionComponent } from "react"
import cx from "classnames"
import { ISwitchOptionProps } from "./SwitchOption"
import SwitchOptionInternal from "./SwitchOptionInternal"

interface ISwitchProps extends React.HTMLAttributes<HTMLDivElement> {
    value: any
    onSwitch: (value: any) => void
    theme?: "round" | "square"
    fullWidth?: boolean
}

const Switch: FunctionComponent<React.PropsWithChildren<ISwitchProps>> = ({
    value,
    onSwitch,
    children,
    className,
    theme = "round",
    fullWidth = false,
    ...others
}) => {

    const options = React.useMemo(() => {
        return React.Children.map(children, c => {
            if (!c) return null

            const child = c as React.ReactElement<any, React.JSXElementConstructor<ISwitchOptionProps>>

            return (
                <SwitchOptionInternal {...child.props}
                    isSelected={value === child.props.value}
                    onClick={() => onSwitch(child.props.value)}
                    tooltip={child.props.tooltip}
                />
            )
        })
    }, [children, onSwitch, value])

    return (
        <div className={cx([
            "switch",
            `switch--${theme}`,
            fullWidth && "switch--full-width",
            className,
        ])}
            {...others}>
            <ul className="switch__options">
                {options}
            </ul>
        </div>
    )
}

export default Switch
